module.exports = `fragment news_banner on Contentstack_news_banner {
    news_banner_post {
      url
      title
      body
      seo {
        ...seo
      }
    }
  }`;